import { IFilterFormOptionValue } from '../models/filter-form.interface';

/** The only LGBTQIA+ option: no second option exists, so a negative filter is unrepresentable. */
export const LGBT_IDENTIFIED_OPTION: IFilterFormOptionValue = { title: 'Yes', tag: 'yes' };
